var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBaseWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9609 0.0996094C16.1433 0.0996094 17.2231 0.698754 17.8506 1.70215L17.8564 1.71094L29.3086 20.4082V20.4092C29.6443 20.9483 29.8223 21.5704 29.8223 22.208C29.8221 24.086 28.294 25.614 26.416 25.6143H3.50684C1.62865 25.6143 0.0997263 24.0862 0.0996094 22.208C0.0996094 21.5704 0.277623 20.9483 0.613281 20.4092V20.4082L12.0703 1.70215L12.0713 1.70312C12.6987 0.699347 13.7783 0.0996454 14.9609 0.0996094ZM14.9609 2.2373C14.5221 2.23734 14.12 2.46028 13.8857 2.83203V2.83301L2.42871 21.5371C2.30346 21.7376 2.2373 21.9699 2.2373 22.208C2.23742 22.9076 2.80719 23.4766 3.50684 23.4766H26.416C27.1155 23.4763 27.6844 22.9075 27.6846 22.208C27.6846 22.0295 27.6475 21.8542 27.5762 21.6934L27.4932 21.5371L27.4873 21.5283L16.0361 2.83301V2.83105L15.9404 2.69922C15.7006 2.40772 15.3449 2.2373 14.9609 2.2373Z",
    fill: "#DD2025",
    stroke: "white",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9639 18.8008C15.5541 18.8008 16.0322 19.2799 16.0322 19.8701C16.0322 20.4603 15.5541 20.9384 14.9639 20.9385C14.3736 20.9385 13.8946 20.4604 13.8945 19.8701C13.8945 19.2798 14.3736 18.8008 14.9639 18.8008Z",
    fill: "#DD2025",
    stroke: "white",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9639 7.11133C15.5541 7.11139 16.0322 7.5904 16.0322 8.18066V15.1934C16.0322 15.7836 15.5541 16.2626 14.9639 16.2627C14.3736 16.2627 13.8945 15.7837 13.8945 15.1934V8.18066C13.8945 7.59036 14.3736 7.11133 14.9639 7.11133Z",
    fill: "#DD2025",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseWarning);
export default __webpack_public_path__ + "static/media/base_warning.e91f96a932a0592de19e383187f2b21d.svg";
export { ForwardRef as ReactComponent };